import { useState } from "react";
import { MenuItem } from "@affinitysystemsgroup/github-packages-affinity-components/dist/src/interfaces/interface";

export const useClickMenu = () => {
	const [selectedUserId, setSelectedUserId] = useState<string>("");

	const handleClickMenu = (e: any, options: MenuItem[]) => {
		console.log("e", e);
		console.log("options", options);
		setSelectedUserId(e.id);

		switch (e.id) {
			case "1":
				console.log("modificar");
				break;
			case "2":
				console.log("eliminar");
				break;
			case "3":
				handleEnableDisableUser(options);
				break;
			case "4":
				console.log("ver roles");
				break;  
			default:
				break;
		}
	};

	const handleEnableDisableUser = (options: MenuItem[]) => {
		console.log("options", options);
	}

	return {
		handleClickMenu,
		selectedUserId
	};
};
